import { ApexOptions } from "apexcharts";
import { ProductOrderTypes } from "../../../Types/DashboardsType";
import { TableColumn } from "react-data-table-component";
import { FormGroup, Input, Label } from "reactstrap";
import { Badges, H6, Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";


export const monthlyDropdownList = ['Weekly', 'Monthly', 'Yearly'];

//charts
export const categoriesoptions: ApexOptions = {
    series: [52, 35, 15, 45],
    chart: {
        type: 'donut',
        height: 200,
    },
    dataLabels: {
        enabled: false
    },
    legend: {
        show: false
    },
    responsive: [{
        breakpoint: 1700,
        options: {
            chart: {
                height: 150
            },
        },
    }, {
        breakpoint: 1441,
        options: {
            chart: {
                height: 205
            },
        },
    }, {
        breakpoint: 991,
        options: {
            chart: {
                height: 160
            },
        },
    }, {
        breakpoint: 421,
        options: {
            chart: {
                height: 170
            },
        },
    }
    ],
    plotOptions: {
        pie: {
            expandOnClick: false,
            donut: {
                size: "70%",
                labels: {
                    show: true,
                    value: {
                        offsetY: 5,
                    },
                    total: {
                        show: true,
                        fontSize: "14px",
                        color: "#9B9B9B",
                        fontFamily: "Outfit', sans-serif",
                        fontWeight: 400,
                        label: "Total",
                        formatter: () => "60%",
                    },
                },
            },
        },
    },
    yaxis: {
        labels: {
            formatter: function (val) {
                return val / 100 + "$";
            },
        },
    },
    colors: ["#008dab", '#DC3545', '#F3F3F3', "#EBA31D"],
};

export const earnedOptions: ApexOptions = {
    series: [{
        name: "Desktops",
        data: [50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62],
    }],
    chart: {
        type: 'area',
        height: 200,
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: true,
            top: 5,
            left: 0,
            blur: 2,
            color: "#008dab",
            opacity: 0.2,
        },
    },
    colors: ["#008dab"],
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.6,
            opacityTo: 0.2,
            stops: [0, 100, 100]
        }
    },
    dataLabels: {
        enabled: false
    },
    grid: {
        show: false,
    },
    xaxis: {
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
    stroke: {
        curve: 'smooth',
        width: 2,
    },
};


export const monthlyGrowthOptions: ApexOptions = {
    series: [{
        name: 'Growth',
        data: [0, 14, 5, 20, 14, 30]
    }],
    chart: {
        height: 120,
        type: 'line',
        stacked: true,
        offsetY: 40,
        toolbar: {
            show: false
        },
    },
    grid: {
        show: false,
        borderColor: '#000000',
        strokeDashArray: 0,
        position: 'back',
        xaxis: {
            lines: {
                show: false,
            },
        },
        yaxis: {
            lines: {
                show: false,
            },
        },
    },
    colors: ["#008dab"],
    stroke: {
        width: 3,
        curve: 'smooth'
    },
    xaxis: {
        labels: {
            show: false
        },
        axisTicks: {
            show: false
        },
        axisBorder: {
            show: false
        },
    },
    yaxis: {
        min: -10,
        max: 40,
        labels: {
            show: false
        }
    },
    markers: {
        discrete: [{
            seriesIndex: 0,
            dataPointIndex: 0,
            fillColor: "#008dab",
            strokeColor: "#008dab",
            size: 4,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 1,
            fillColor: "#008dab",
            strokeColor: "#008dab",
            size: 4,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 2,
            fillColor: "#008dab",
            strokeColor: "#008dab",
            size: 4,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 3,
            fillColor: "#008dab",
            strokeColor: "#008dab",
            size: 4,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 4,
            fillColor: "#008dab",
            strokeColor: "#008dab",
            size: 4,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 5,
            fillColor: "#fff",
            strokeColor: "#008dab",
            size: 5,
            shape: "circle"
        },
        ],
    },
};

export const invoicesCard: ApexOptions  = {
    series: [
      {
        data: [
          40, 50, 50, 50, 25, 25, 25, 60, 60, 60, 60, 45, 45, 45, 45, 25, 25, 25,
          25, 25, 60,
        ],
      },
    ],
    chart: {
      type: "line",
      height: 70,
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: true,
        top: 8,
        left: 3,
        blur: 2,
        color: "#008dab",
        opacity: 0.4,
      },
    },
    stroke: {
      curve: "stepline",
      width: 2,
    },
    colors: ["#008dab"],
    fill: {
      opacity: [0.5, 0.25, 1],
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    markers: {
      hover: {
        sizeOffset: 4,
      },
      discrete: [
        {
          seriesIndex: 0,
          dataPointIndex: 1,
          fillColor: "#fff",
          strokeColor: "#008dab",
          size: 3,
          shape: "circle",
        },
        {
          seriesIndex: 0,
          dataPointIndex: 4,
          fillColor: "#fff",
          strokeColor: "#008dab",
          size: 3,
          shape: "circle",
        },
        {
          seriesIndex: 0,
          dataPointIndex: 7,
          fillColor: "#fff",
          strokeColor: "#008dab",
          size: 3,
          shape: "circle",
        },
        {
          seriesIndex: 0,
          dataPointIndex: 11,
          fillColor: "#fff",
          strokeColor: "#008dab",
          size: 3,
          shape: "circle",
        },
        {
          seriesIndex: 0,
          dataPointIndex: 15,
          fillColor: "#fff",
          strokeColor: "#008dab",
          size: 3,
          shape: "circle",
        },
        {
          seriesIndex: 0,
          dataPointIndex: 20,
          fillColor: "#fff",
          strokeColor: "#008dab",
          size: 3,
          shape: "circle",
        },
      ],
    },
    responsive: [
      {
        breakpoint: 1320,
        options: {
          chart: {
            offsetX: 0,
          }
        },
      },
      {
        breakpoint: 1236,
        options: {
          chart: {
            height: 80,
          }
        },
      },    
      {
        breakpoint: 381,
        options: {
          chart: {
            width: 200,
           offsetX: 25,
          }
        },
      },
    ],
  };
  

//datas
export const categoriesSalesData = [
    {
        id: 1,
        color: 'primary',
        title: 'Income',
        rate: '21,654'
    },
    {
        id: 2,
        color: 'secondary',
        title: 'Visitors',
        rate: '62,842'
    },
    {
        id: 3,
        color: 'danger',
        title: 'Expense',
        rate: '37,210'
    },
];

export const orderOverviewData = [
    {
        id: 1,
        value: 40,
        text: 'Online Order',
        color: 'primary'
    },
    {
        id: 2,
        value: 60,
        text: 'Offline Order',
        color: 'secondary'
    },
    {
        id: 3,
        value: 20,
        text: 'Cash On Develery',
        color: 'success'
    }
];

export const discountCardData = [
    {
        id: 1,
        brand: 'IPhone 14 Pro',
        discount: 21.45,
        price: 65.40,
        deal: 48,
        time: [
            { id: 1, digit: 28, text: 'Days' },
            { id: 2, digit: 3, text: 'Hours' },
            { id: 3, digit: 14, text: 'Min' },
            { id: 4, digit: 45, text: 'Sec' },
        ],
        image: '7.png'
    },
    {
        id: 2,
        brand: 'Apple Airpods',
        discount: 20.35,
        price: 35.43,
        deal: 38,
        time: [
            { id: 1, digit: 20, text: 'Days' },
            { id: 2, digit: 5, text: 'Hours' },
            { id: 3, digit: 30, text: 'Min' },
            { id: 4, digit: 15, text: 'Sec' },
        ],
        image: '8.png'
    },
    {
        id: 3,
        brand: 'Apple Watch Series 7',
        discount: 25.30,
        price: 45.40,
        deal: 25,
        time: [
            { id: 1, digit: 15, text: 'Days' },
            { id: 2, digit: 6, text: 'Hours' },
            { id: 3, digit: 18, text: 'Min' },
            { id: 4, digit: 30, text: 'Sec' },
        ],
        image: '9.png'
    },
];

export const discountSliderOptions = {
    dots: true,
    AutoPlay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
};

export const priceChartOptions1: ApexOptions = {
    series: [
        {
            data: [1, 20, 10, 30, 10, 55, 20, 30],
        },
    ],
    chart: {
        type: 'line',
        width: '80',
        height: 15,
        sparkline: {
            enabled: true,
        },
    },
    fill: {
        opacity: 1,
    },
    colors: ["#479447"],
    stroke: {
        curve: 'smooth',
        width: 3,
    },

    tooltip: {
        enabled: false,
    },
}

export const priceChartOptions2: ApexOptions = {
    series: [
        {
            data: [1, 25, 10, 25, 25, 18, 25, 10, 30],
        },
    ],
    chart: {
        type: 'line',
        width: '80',
        height: 15,
        sparkline: {
            enabled: true,
        },
    },
    fill: {
        opacity: 1,
    },
    colors: ["#da9817"],
    stroke: {
        curve: 'smooth',
        width: 3,
    },

    tooltip: {
        enabled: false,
    },
}

export const priceChartOptions3: ApexOptions = {
    series: [
        {
            data: [1, 25, 10, 25, 25, 10, 25, 18, 30],
        },
    ],
    chart: {
        type: 'line',
        width: '80',
        height: 15,
        sparkline: {
            enabled: true,
        },
    },
    fill: {
        opacity: 1,
    },
    colors: ["#479447"],
    stroke: {
        curve: 'smooth',
        width: 3,
    },

    tooltip: {
        enabled: false,
    },
}

export const priceChartOptions4: ApexOptions = {
    series: [
        {
            data: [1, 25, 10, 25, 25, 18, 25, 10, 30],
        },
    ],
    chart: {
        type: 'line',
        width: '80',
        height: 15,
        sparkline: {
            enabled: true,
        },
    },
    fill: {
        opacity: 1,
    },
    colors: ["#da9817"],
    stroke: {
        curve: 'smooth',
        width: 3,
    },

    tooltip: {
        enabled: false,
    },
}

export const productOrderData: ProductOrderTypes[] = [
    {
        id: 1,
        image: '5.png',
        product: 'T-shirt',
        subText: 'Free delivery',
        date: '16 Aug',
        stock: '65554',
        chart: {
            ...priceChartOptions1,
            series: priceChartOptions1.series,
            type: priceChartOptions1.chart?.type,
            height: priceChartOptions1.chart?.height,
            width: priceChartOptions1.chart?.width
        },
        rate: '$84464',
        badgeColor: 'primary',
        badge: 'Done'
    },
    {
        id: 2,
        image: '6.png',
        product: 'Sports Shoes',
        subText: '$83.97 delivery',
        date: '2 Oct',
        stock: '65491',
        chart: {
            ...priceChartOptions2,
            series: priceChartOptions2.series,
            type: priceChartOptions2.chart?.type,
            height: priceChartOptions2.chart?.height,
            width: priceChartOptions2.chart?.width
        },
        rate: '$28239',
        badgeColor: 'warning',
        badge: 'Pending'
    },
    {
        id: 3,
        image: '3.png',
        product: 'Smart Watch',
        subText: 'Free delivery',
        date: '21 Mar',
        stock: '95361',
        chart: {
            ...priceChartOptions3,
            series: priceChartOptions3.series,
            type: priceChartOptions3.chart?.type,
            height: priceChartOptions3.chart?.height,
            width: priceChartOptions3.chart?.width
        },
        rate: '$84568',
        badgeColor: 'primary',
        badge: 'Done'
    },
    {
        id: 4,
        image: '4.png',
        product: 'Laptop Bag',
        subText: '$12.55 delivery',
        date: '31 Dec',
        stock: '98744',
        chart: {
            ...priceChartOptions4,
            series: priceChartOptions4.series,
            type: priceChartOptions4.chart?.type,
            height: priceChartOptions4.chart?.height,
            width: priceChartOptions4.chart?.width
        },
        rate: '$84464',
        badgeColor: 'warning',
        badge: 'Pending'
    },
]

export const productOrderColumns: TableColumn<ProductOrderTypes>[] = [
    {
        name: (
            <FormGroup check>
                <Input type="checkbox" value="" />
                <Label check></Label>
            </FormGroup>),
        sortable: false,
        cell: () => {
            return (
                <FormGroup check>
                    <Input type="checkbox" value="" />
                    <Label check></Label>
                </FormGroup>
            );
        },
        width: '5%'
    },
    {
        name: "Product name",
        selector: (row) => row.product,
        sortable: true,
        cell: (row) => (
            <div className="d-flex">
                <div className="flex-shrink-0"><Image src={dynamicImage(`dashboard-2/product/${row.image}`)} alt="" /></div>
                <div className="flex-grow-1">
                    <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product`}>
                        <H6 className="f-w-600">{row.product}</H6>
                        <span>{row.subText}</span>
                    </Link>
                </div>
            </div>
        )
    },
    {
        name: "Date",
        selector: (row) => row.date,
        sortable: true,
    },
    {
        name: "Stock",
        selector: (row) => row.stock,
        sortable: true,
    },
    {
        name: "Value",
        selector: (row) => row.chart,
        sortable: true,
        cell: (row) => <div id="priceChart2">
            <ReactApexChart options={row.chart} series={row.chart.series} type={row.chart.type} height={row.chart.height} width={row.chart.width} />
        </div>,

    },
    {
        name: "Rate",
        selector: (row) => row.rate,
        sortable: true,
    },
    {
        name: "Payment",
        selector: (row) => row.badge,
        sortable: true,
        cell: (row) => <Badges color={`light-${row.badgeColor}`} className={`txt-${row.badgeColor}`} pill>{row.badgeColor === "primary" ? "Done" : "Pending"}</Badges>
    },
];

export const newOrderData = [
    {
        id: 1,
        image: '14.jpg',
        name: 'Pot',
        subText: '100',
        code: '3LIX040',
        percent: '-65',
        price: '99.00'
    },
    {
        id: 2,
        image: '15.jpg',
        name: 'iphone',
        subText: '380 Item',
        code: 'JP563',
        percent: '-19',
        price: '69.00'
    },
    {
        id: 3,
        image: '18.jpg',
        name: 'Headphone',
        subText: '513 Item',
        code: 'MH723',
        percent: '-92',
        price: '84.00'
    },
    {
        id: 4,
        image: '17.jpg',
        name: 'Glass',
        subText: '235 Item',
        code: 'DFG87',
        percent: '-67',
        price: '34.00'
    },
    {
        id: 5,
        image: '16.jpg',
        name: 'Watch',
        subText: '365 Item',
        code: 'TRX938',
        percent: '-20',
        price: '31.00'
    }
]

export var userActivityChart: ApexOptions = {
    chart: {
        height: 285,
        type: "radialBar"
    },
    series: [69],
    colors: ["#008dab"],
    plotOptions: {
        radialBar: {
            hollow: {
                size: "57%"
            },
            track: {
                background: ["#008dab"],
                opacity: 0.2,
            },
            dataLabels: {
                name: {
                    show: true,
                    color: "#9B9B9B",
                    fontSize: "20px",
                    fontWeight: "600",
                },
                value: {
                    color: "#363636",
                    fontSize: "24px",
                    fontWeight: "500",
                    show: true
                }
            }
        }
    },
    stroke: {
        lineCap: "round",
    },
    responsive: [
        {
            breakpoint: 1400,
            options: {
                chart: {
                    height: 335,
                }
            }
        },
        {
            breakpoint: 1200,
            options: {
                chart: {
                    height: 290,
                }
            }
        },
        {
            breakpoint: 360,
            options: {
                chart: {
                    height: 250,
                }
            }
        }
    ],
    labels: ["Activity"]
};

export const applicationsMenu = [
    {
        id: 1,
        title: 'Online Applications',
        value: 60
    },
    {
        id: 2,
        title: 'Offline Applications',
        value: 39
    }
]

export const monthlyInvoicesData = [
    {
        id: 1,
        icon: 'bookmark',
        title: 'Growth of Camelun iOS',
        subText: '20 paid month out of 24',
        price: '15.00',
        link: `invoice-1`
    },
    {
        id: 2,
        icon: 'Ticket-Star',
        title: 'ReactDT Motions',
        subText: 'Late payment  12 week - pay invoce',
        price: '20.00',
        link: `invoice-4`
    },
    {
        id: 3,
        icon: 'Discovery',
        title: 'Arocca Store',
        subText: 'Error sending payment - Detail information',
        price: '30.00',
        link: `invoice-2`
    },
    {
        id: 4,
        icon: 'Shield-Done',
        title: 'EnterPress Project',
        subText: '25 paid days out of 113',
        price: '18.00',
        link: `invoice-3`
    }
]

export var optionsRevenue: ApexOptions = {
    series: [
        {
            type: 'area',
            data: [35, 40, 30, 46, 36, 45]
        },
        {
            type: 'line',
            data: [27, 25, 48, 50, 44, 53],
        },
    ],
    chart: {
        type: 'line',
        height: 358,
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false
        },
        dropShadow: {
            enabled: true,
            top: 8,
            left: 0,
            blur: 3,
            color: "#008193",
            opacity: 0.2
        }
    },
    colors: ["#008dab", "#e87f24"],
    dataLabels: {
        enabled: false
    },
    legend: {
        show: false,
    },
    stroke: {
        curve: 'smooth',
        width: [2, 3],
        dashArray: [0, 2]
    },
    grid: {
        show: true,
        borderColor: '#F3F3F3',
        position: 'back',
    },
    tooltip: {
        x: {
            show: false,
        },
    },
    plotOptions: {
        bar: {
            borderRadius: 6,
        }
    },
    fill: {
        opacity: [0.05, 1],
    },
    xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        labels: {
            style: {
                colors: '#363636',
                fontWeight: 500,
                fontFamily: "Poppins, sans-serif",
            },
        },
        axisTicks: {
            show: false,
        },
        axisBorder: {
            show: false
        },
        crosshairs: {
            show: true,
            width: 30,
            position: "back",
            opacity: 0.2,
            stroke: {
                color: '#008193',
                width: 0,
                dashArray: 0,
            },
            fill: {
                type: "solid",
                color: "#008dab",
            },
        },
    },
    yaxis: {
        logBase: 10,
        tickAmount: 5,
        min: 10.00,
        max: 60.00,
        labels: {
            show: true,
            align: 'right',
            style: {
                colors: '#363636',
                fontWeight: 500,
                fontFamily: "Poppins, sans-serif",
            },
            formatter: (value) => {
                return `$${value}0`;
            },
        },
    },
};

export const notificationsCardData = [
    {
        id: 1,
        image: '5.png',
        details: [
            {
                name: 'Zaynab Azzahr',
                text: 'recommended this online shop to buy electronics,'
            },
            {
                name: 'Elecktrosop'
            }
        ],
        subText: 'Elecktroshop',
        time: 'Now'
    },
    {
        id: 2,
        image: '6.png',
        details: [
            {
                name: 'Erin Porit',
                text: 'sent the goods for you to see'
            },
        ],
        subText: 'New item',
        time: '25m ago'
    },
    {
        id: 3,
        image: '7.png',
        details: [
            {
                name: 'Wildan',
                text: 'changed'
            },
            {
                name: 'the cosmetic payment',
                text: 'due date to sunday '
            },
            {
                name: '06 March 2024'
            }
        ],
        subText: 'Payment',
        time: '2h ago'
    },
    {
        id: 4,
        image: '8.png',
        details: [
            {
                name: 'Erin Porit',
                text: 'sent the goods for you to see'
            },
            {
                name: 'New item'
            }
        ],
        subText: 'Elecktroshop',
        time: '4h ago'
    }
]

export const saleTopCountriesData = [
    {
        id: 1,
        data: [
            {
                id: 1,
                country: 'India',
                value: 70
            },
            {
                id: 2,
                country: 'Australia',
                value: 35
            }
        ]
    },
    {
        id: 2,
        data: [
            {
                id: 1,
                country: 'Dubai',
                value: 40
            },
            {
                id: 2,
                country: 'Brazil',
                value: 50
            }
        ]
    }
]

export const reviewSlider = {
    slidesToShow: 1,
    swipeToSlide: true,
    arrows: false,
    dots: true,
};

export const socialReviewList = [
    { id: 1, link: 'https://www.facebook.com/', icon: 'facebook' },
    { id: 2, link: 'https://accounts.google.com/', icon: 'google-plus' },
    { id: 3, link: 'https://twitter.com/', icon: 'twitter' },
    { id: 4, link: 'https://www.facebook.com/', icon: 'instagram' },
    { id: 5, link: 'https://www.facebook.com/', icon: 'rss' },

]

export const reviewSliderData = [
    {
        id: 1,
        image: '9.png',
        title: 'John Connor',
        rate: '4.3',
        number: '136',
        paragraph: "“Best  Product i’ve been seen on market, best price, best quality! Overall Amazing!!!”"
    },
    {
        id: 2,
        image: '10.png',
        title: 'Paul Miller',
        rate: '5.6',
        number: '120',
        paragraph: `"The best product I've seen on the market, best price, and best quality!" Overall, Amazing!!!"`
    },
    {
        id: 3,
        image: '11.png',
        title: 'Alen Lee',
        rate: '6.3',
        number: '140',
        paragraph: `"greatest product I've ever seen on the market, greatest pricing, and best quality! Overall, great!!!"`
    }
]

export const groupChartOption: ApexOptions = {
    series: [
        {
            name: "Good",
            data: [380, 600, 500, 800, 650, 480, 520, 380, 620, 400, 380, 550],
        },
        {
            name: "Very Good",
            data: [690, 500, 600, 600, 500, 650, 800, 400, 400, 550, 450, 500],
        },
    ],
    colors: ["#008dab", "#e87f24"],
    chart: {
        type: "bar",
        height: 325,
        offsetX: 0,
        toolbar: {
            show: false,
        },
    },
    plotOptions: {
        bar: {
            horizontal: false,
        },
    },
    stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
    },
    grid: {
        show: true,
        borderColor: "#E5E5E5",
        position: "back",
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        enabled: false,
    },
    yaxis: {
        show: true,
        labels: {
            show: true,
            style: {
                colors: '#363636',
                fontWeight: 500,
                fontFamily: "Poppins, sans-serif",
            },
            formatter: (value) => {
                return `${value}k`;
            },
        },
    },
    xaxis: {
        categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ],
        labels: {
            show: true,
            style: {
                colors: '#363636',
                fontWeight: 500,
                fontFamily: "Poppins, sans-serif",
            },
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    legend: {
        show: false,
    },
    responsive: [
        {
            breakpoint: 1399,
            options: {
                chart: {
                    height: 300,
                },
                series: [
                    {
                        name: "Good",
                        data: [170, 250, 350, 150, 230, 120, 330, 350, 280],
                    },
                    {
                        name: "Very Good",
                        data: [290, 180, 120, 290, 370, 250, 230, 200, 140],
                    },
                ],
            },
        },
        {
            breakpoint: 835,
            options: {
                chart: {
                    height: 315,
                },
                series: [
                    {
                        name: "Good",
                        data: [170, 250, 350, 150, 230, 120, 330],
                    },
                    {
                        name: "Very Good",
                        data: [290, 180, 120, 290, 370, 250, 230],
                    },
                ],
            },
        },
    ],
};